<template>
  <div class="loading-offers" v-show="loadingRooms">
    <div class="loading-offers__loader">
      <span></span>
      <span></span>
      <span></span>
      <span></span>
    </div>
    <div class="loading-offers__text">
      We're getting the best available offers
    </div>
  </div>
</template>
<script setup lang="ts">
import { useSearchStore } from "~/store/search";
const searchStore = useSearchStore();
const loadingRooms = computed(() => searchStore.loadingRooms);
</script>

<style lang="scss">
.loading-offers {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 340px;
  height: 114px;
  gap: 12px;
  border-radius: 6px;
  border: 1px solid #EFF6F6;
  padding: 24px;
  margin: 0 auto;
  box-shadow: 0 2px 4px 0 #16161629;

  &__text {
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    letter-spacing: 0;
    text-align: center;
  }

  &__loader {
    display: flex;
    gap: 4px;

    span {
      display: flex;
      width: 10px;
      height: 10px;
      border-radius: 50%;
      background-color: var(--blue);
      animation: bounce 1.2s infinite ease-in-out;
    }
  }


  &__loader span:nth-child(2) {
    animation-delay: 0.15s;
  }

  &__loader span:nth-child(3) {
    animation-delay: 0.35s;
  }

  &__loader span:nth-child(4) {
    animation-delay: 0.5s;
  }
}

@keyframes bounce {
  0%, 80%, 100% {
    transform: translateY(0);
    opacity: 0.7;
  }
  40% {
    transform: translateY(-6px);
    opacity: 1;
  }
}
</style>
